import { useState } from 'react';
import appConstants from '../../../../constants';
import saveUserPartnerService from '../../../../services/saveUserPartnerService';
import deleteUserPartnerService from '../../../../services/deleteUserPartnerService';

const constants = Object.freeze({
  HOOK_NAME: 'useUserPartnerOperations'
});

export default function useUserPartnerOperations() {

  const [isUserPartnerOperationInProgress, setIsUserPartnerOperationInProgress] = useState(false);
  const [userPartnerOperationError, setUserPartnerOperationError] = useState(null);

  function saveUserPartner(
    userId,
    partnerBeGeoId,
    partnerSiteId,
    onSuccessfulUserPartnerSavingFn,
    onFailedUserPartnerSavingFn
  ) {
    const FUNCTION_NAME = 'saveUserPartner';

    async function doSaveUserPartner(userId, partnerBeGeoId, partnerSiteId, onSuccessFn, onFailureFn) {
      const saveUserPartnerOperation = await saveUserPartnerService(userId, partnerBeGeoId, partnerSiteId);
      if(!saveUserPartnerOperation.hasError) {
        if(!!onSuccessFn && 'function' === typeof onSuccessFn) {
          setUserPartnerOperationError(null);
          onSuccessFn();
        }
      }
      else {
        if(!!onFailureFn && 'function' === typeof onFailureFn) {
          setUserPartnerOperationError(saveUserPartnerOperation.errorMessage);
          onFailureFn(saveUserPartnerOperation.errorMessage);
        }
      }
      setIsUserPartnerOperationInProgress(false);
    }

    let hasValidationError = false;
    let validationErrorMessage;
    let validUserId = userId||'';
    validUserId = `${validUserId}`.trim();
    if(!validUserId.length || validUserId.toLowerCase() === 'guest') {
      validationErrorMessage = `${constants.HOOK_NAME} // ${FUNCTION_NAME}: invalid user id.`;
      hasValidationError = true;
    }
    let validPartnerBeGeoId = partnerBeGeoId||'';
    validPartnerBeGeoId = `${validPartnerBeGeoId}`.trim();
    if(!validPartnerBeGeoId.length) {
      validationErrorMessage = `${constants.HOOK_NAME} // ${FUNCTION_NAME}: invalid partner be geo id. (${partnerBeGeoId})`;
      hasValidationError = true;
    }
    let validPartnerSiteId = partnerSiteId||'';
    validPartnerSiteId = `${validPartnerSiteId}`.trim();
    if(!validPartnerSiteId.length) {
      validationErrorMessage = `${constants.HOOK_NAME} // ${FUNCTION_NAME}: invalid partner site id. (${partnerSiteId})`;
      hasValidationError = true;
    }

    if (hasValidationError) {
      console.error(validationErrorMessage);
      onFailedUserPartnerSavingFn();
    }
    else {
      setIsUserPartnerOperationInProgress(true);
      doSaveUserPartner(
        validUserId,
        validPartnerBeGeoId,
        validPartnerSiteId,
        onSuccessfulUserPartnerSavingFn,
        onFailedUserPartnerSavingFn
      );
    }
  }


  function removeUserPartner(
    userId,
    favTrackId,
    onSuccessfulUserPartnerDeletionFn,
    onFailedUserPartnerDeletionFn
  ) {
    const FUNCTION_NAME = 'removeUserPartner';

    async function doRemoveUserPartner(userId, favTrackId, onSuccessFn, onFailureFn) {
      const deleteUserPartnerOperation = await deleteUserPartnerService(userId, favTrackId);
      if(!deleteUserPartnerOperation.hasError) {
        if(!!onSuccessFn && 'function' === typeof onSuccessFn) {
          setUserPartnerOperationError(null);
          onSuccessFn();
        }
      }
      else {
        if(!!onFailureFn && 'function' === typeof onFailureFn) {
          setUserPartnerOperationError(deleteUserPartnerOperation.errorMessage);
          onFailureFn(deleteUserPartnerOperation.errorMessage);
        }
      }
      setIsUserPartnerOperationInProgress(false);
    }

    let hasValidationError = false;
    let validationErrorMessage;
    let validUserId = userId||'';
    validUserId = `${validUserId}`.trim();
    if(!validUserId.length || validUserId.toLowerCase() === 'guest') {
      validationErrorMessage = `${constants.HOOK_NAME} // ${FUNCTION_NAME}: invalid user id.`;
      hasValidationError = true;
    }
    let validFavTrackId = favTrackId||'';
    validFavTrackId = `${validFavTrackId}`.trim();
    if(!validFavTrackId.length) {
      validationErrorMessage = `${constants.HOOK_NAME} // ${FUNCTION_NAME}: invalid favorite track id. (${favTrackId})`;
      hasValidationError = true;
    }

    if (hasValidationError) {
      console.error(validationErrorMessage);
      onFailedUserPartnerDeletionFn();
    }
    else {
      setIsUserPartnerOperationInProgress(true);
      doRemoveUserPartner(
        validUserId,
        validFavTrackId,
        onSuccessfulUserPartnerDeletionFn,
        onFailedUserPartnerDeletionFn
      );
    }

  }

  return {
    isUserPartnerOperationInProgress,
    userPartnerOperationError,
    saveUserPartner,
    removeUserPartner
  }
}
